"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalLocaleAmbientValue = exports.LocaleAmbientValue = void 0;
const AmbientValue_1 = require("./AmbientValue");
class LocaleAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "locale";
    }
}
exports.LocaleAmbientValue = LocaleAmbientValue;
class OptionalLocaleAmbientValue extends AmbientValue_1.AmbientValue {
    constructor() {
        super(...arguments);
        this.name = "locale?";
    }
}
exports.OptionalLocaleAmbientValue = OptionalLocaleAmbientValue;
//# sourceMappingURL=LocaleAmbientValue.js.map